import React from "react";
import { IKImage } from "imagekitio-next";
import { useTranslation } from "next-i18next";

type AdminCommentImagePropsType = {
  imageUrl: string;
  width: number;
  height: number;
};
const ADMIN_COMMENT_IMAGE_RATIO_MULTIPLIE = 5;
function AdminCommentImage({ imageUrl, width, height }: AdminCommentImagePropsType) {
  const { t: categoriesTranslate } = useTranslation("categories");
  const ratio = width / height;
  const ADMIN_COMMENT_IMAGE_WIDTH = height;
  const ADMIN_COMMENT_IMAGE_HEIGHT = (1 / ratio) * height;
  return (
    <IKImage
      urlEndpoint={process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL}
      src={imageUrl}
      transformation={[
        {
          crop: "maintain_ratio",
          cropMode: "pad_resize",
        },
      ]}
      width={ADMIN_COMMENT_IMAGE_WIDTH * ADMIN_COMMENT_IMAGE_RATIO_MULTIPLIE}
      height={ADMIN_COMMENT_IMAGE_HEIGHT * ADMIN_COMMENT_IMAGE_RATIO_MULTIPLIE}
      alt={categoriesTranslate(`imageNotFound`)}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className="rounded-md cursor-pointer hover:scale-105 transition-transform duration-200 ease-in-out max-w-full h-full"
    />
  );
}

export default AdminCommentImage;
